import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import { API_IP} from '../util/config';
import {StorageService} from './common/storage.service';
import {CookieService} from 'ngx-cookie-service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChangTabService {
  public tab: BehaviorSubject<string> = new BehaviorSubject<string>('默认项');
  public verificationCode: BehaviorSubject<string> = new BehaviorSubject<string>('默认项')
  requestURL;

  constructor(
      public http: HttpClient,
      public storageService: StorageService,
      public cookieService: CookieService
  ) { }

  getAppStatus() {
    this.requestURL = API_IP + '/appStatus';
    return this.http.post(this.requestURL , {});
  }

}
